"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackHistoryEvent = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackHistoryEvent({ action, label, nonInteraction, }) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: 'Search',
        eventAction: action,
        eventLabel: label,
        nonInteraction,
    });
}
exports.trackHistoryEvent = trackHistoryEvent;
//# sourceMappingURL=trackHistoryEvent.js.map